import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M19 18l-14 -6l14 -6","key":"svg-0"}]]

const IconMathLower = createReactComponent('outline', 'math-lower', 'MathLower', __iconNode);

export default IconMathLower;